import script from "./ChallengeCertificateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChallengeCertificateModal.vue?vue&type=script&setup=true&lang=js"

import "./ChallengeCertificateModal.vue?vue&type=style&index=0&id=f114c75a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f114c75a"]])

export default __exports__